// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"RichText_contentContainer__hUAfx"};